import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  Typography,
  Flex,
  Space,
  Divider,
} from "antd";
import { CheckOutlined } from "@ant-design/icons";
import HacktonomyPageLoader from "../../components/HactonomyPageLoader";

const { Title, Text } = Typography;

function PracticeTests() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // replace with your real API call, e.g.:
    // fetchPracticeTests().then(() => setLoading(false));
    setLoading(false); // temporary, until real fetch is wired in
  }, []);

  const tests = [
    {
      title: "Practice test 1 — Full length",
      details: "100 questions · 120 min · Last score 71%",
      completed: true,
      action: "Retake",
    },
    {
      title: "Practice test 2 — Full length",
      details: "100 questions · 120 min · Not attempted",
      completed: false,
      action: "Start",
    },
    {
      title: "Quick drill — Secure coding",
      details: "20 questions · 20 min",
      completed: false,
      action: "Start",
    },
  ];

  const handleAction = (test) => {
    console.log(`${test.action}: ${test.title}`);

    // Add navigation to your actual test page here.
    // Example:
    // navigate("/candidate/practice-tests/1");
  };

  if (loading) {
    return <HacktonomyPageLoader />;
  }

  return (
     <div
    style={{
      padding: "30px 30px 54px",
      minHeight: "100%",
      background: "#f8fafc",
    }}
  >
    <Card
      bordered
      style={{
        borderRadius: 14,
        background: "#ffffff",
      }}
      styles={{
        body: {
          padding: "36px 40px",
        },
      }}
    >
      {/* HEADER */}
      <Space
        direction="vertical"
        size={4}
        style={{
          width: "100%",
        }}
      >
        <Title
          level={2}
          style={{
            margin: 0,
            fontSize: 27,
            fontWeight: 700,
            color: "#101318",
          }}
        >
          Practice tests
        </Title>

        <Text
          type="secondary"
          style={{
            fontSize: 16,
          }}
        >
          Timed mock exams that mirror the real HCASP format.
        </Text>
      </Space>

      {/* TEST LIST */}
      <Space
        direction="vertical"
        size={0}
        style={{
          width: "100%",
          marginTop: 32,
        }}
      >
        {tests.map((test, index) => (
          <React.Fragment key={test.title}>
            <Flex
              align="center"
              justify="space-between"
              gap={24}
              style={{
                width: "100%",
                minHeight: 88,
              }}
            >
              {/* STATUS */}
              <Flex
                align="center"
                justify="center"
                style={{
                  width: 52,
                  height: 52,
                  flexShrink: 0,
                  borderRadius: 12,
                  background: test.completed
                    ? "#e5f7f3"
                    : "#edf3ff",
                  color: test.completed
                    ? "#00a88f"
                    : "#5274b8",
                  fontSize: 20,
                }}
              >
                {test.completed ? <CheckOutlined /> : "-"}
              </Flex>

              {/* TEST INFO */}
              <Flex
                vertical
                gap={4}
                style={{
                  flex: 1,
                  minWidth: 0,
                }}
              >
                <Text
                  strong
                  style={{
                    fontSize: 18,
                    color: "#101318",
                  }}
                >
                  {test.title}
                </Text>

                <Text
                  type="secondary"
                  style={{
                    fontSize: 15,
                  }}
                >
                  {test.details}
                </Text>
              </Flex>

              {/* ACTION */}
              <Button
                type="link"
                onClick={() => handleAction(test)}
                style={{
                  flexShrink: 0,
                  padding: 0,
                  fontSize: 16,
                  fontWeight: 600,
                }}
              >
                {test.action}
              </Button>
            </Flex>

            {index !== tests.length - 1 && <Divider style={{ margin: 0 }} />}
          </React.Fragment>
        ))}
      </Space>
    </Card>
    </div>
  );
}

export default PracticeTests;